import VueI18n from 'vue-i18n';
import languages from '../common/i18n';
import ListDicionario from '../common/functions/dicionario';

export default (Vue) => {
  Vue.use(VueI18n);
  Vue.config.lang = 'pt-br';

  const plugin = new VueI18n(languages);

  Vue.prototype.$t = (key, values) => { // eslint-disable-line
    return ListDicionario.mapa()[key] || plugin.t(key, values);
  };
  Vue.prototype.$tc = (key, choice, values) => {
    const item = ListDicionario.mapa()[key];
    if (item === undefined) {
      return plugin.tc(key, choice, values);
    }
    const choices = item.split('|');
    return choices.length >= choice ? choices[choice - 1].trim() : '';
  };

  return plugin;
};



// WEBPACK FOOTER //
// ./src/config/i18n.js